import { createApp } from 'vue';
import App from '@/App.vue';
import vuetify from '@/plugins/vuetify';
import store from '@/store';
import router from '@/router';
import upperFirst from 'lodash/upperFirst';
import camelCase from 'lodash/camelCase';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueApexCharts from 'vue3-apexcharts';
import AsyncComputed from 'vue-async-computed';
import { installDarkModeHelper, installCookiesStub } from '@/helpers/vuetifyTheme';
import VueTour from 'v3-tour';
import 'v3-tour/dist/vue-tour.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import '@mdi/font/css/materialdesignicons.css';
import '@/assets/style.css';
import '@/assets/vuetify2-compat.css';

/**
 * Vue 3 app entry (vue3-migration).
 * Flowy removed — canvas uses Vue Flow.
 */

const app = createApp(App);

app.use(router);
app.use(store);
app.use(vuetify);
app.use(VueAxios, axios);
app.use(VueApexCharts);
app.use(AsyncComputed);

installDarkModeHelper(app);
app.use(VueTour);
installCookiesStub(app);

app.component('apexchart', VueApexCharts);

const requireComponent = require.context(
  '@/components/base',
  true,
  /[A-Z]\w+\.(vue|js)$/
);

requireComponent.keys().forEach((fileName) => {
  const componentConfig = requireComponent(fileName);
  const componentName = upperFirst(
    camelCase(
      fileName
        .split('/')
        .pop()
        .replace(/\.\w+$/, '')
    )
  );
  app.component(componentName, componentConfig.default || componentConfig);
});

if (process.env.NODE_ENV === 'development') {
  app.config.performance = true;
}

app.mount('#app');
